import { render, staticRenderFns } from "./QuestionsLayout.vue?vue&type=template&id=955f7086&"
import script from "./QuestionsLayout.vue?vue&type=script&lang=js&"
export * from "./QuestionsLayout.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsLayout.vue?vue&type=style&index=0&id=955f7086&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports